export default {
  GET_ORGANIZATION: '/web/main/selector/jigou', /** 获取机构（供货、要货、管辖机构等） */
  GET_SUBLEVEL: '/web/main/selector/gonghuojigou', /**供货机构（供应商）下拉框 - 加载数据 */
  GET_WAREHOUSE:'/web/main/selector/cangku',/**仓库下拉框 - 加载数据 */
  GET_CATEGORY:'/web/main/selector/leibie',/**类别下拉框或树节点分段加载 - 加载数据 */
  GET_BUMEN:'/web/main/selector/bumen',/**类别下拉框或树节点分段加载 - 加载数据 */
  GET_BIAOQIAN:'/web/main/selector/biaoqian',/**类别下拉框或树节点分段加载 - 加载数据 */
  GET_YUANYIN:'/web/main/selector/yuanyin',/**类别下拉框或树节点分段加载 - 加载数据 */
  GET_WUPIN:'/web/main/selector/wupin',/**类别下拉框或树节点分段加载 - 加载数据 */
  GET_CAIPIN:'/web/main/selector/caipin',/**类别下拉框或树节点分段加载 - 加载数据 */
  GET_WAIXIAOKEHU:'/web/main/selector/waixiaokehu',/**类别下拉框或树节点分段加载 - 加载数据 */
  GET_ITEM:'/web/main/selector/item',/**类别下拉框或树节点分段加载 - 加载数据 */
}


// WEBPACK FOOTER //
// ./src/helpers/constants/api/optimize.js